import {RequestOptions} from "@web-libs/core/http/api/http.types";
import {applyTransformers, Transformer} from "@web-libs/util/transformers/transformers.functions";
import {with_} from "@web-libs/util/with/with";


function withBody(init:RequestInit, body?:any): RequestInit {
    if(!body) return init
    if(body instanceof FormData) return with_(init, {body})
    return with_(init, {body: typeof body  === "string" ? body :  JSON.stringify(body)})
}

export type RequestInitTransformer = Transformer<RequestInit, RequestOptions>

function convertFetchOptions(requestOptions?:RequestOptions, transformer?: RequestInitTransformer[]){
    const requestInit: RequestInit = {
        headers: requestOptions?.headers,
    }

    if(requestOptions?.noCache) requestInit.cache = 'no-cache'

    return applyTransformers(requestInit, transformer, requestOptions)
}


function buildFetchOptions(method: string, body: any, requestOptions?: RequestOptions, transformer?: RequestInitTransformer[]): RequestInit {
    const requestInit = convertFetchOptions(requestOptions, transformer)
    const requestInitWithMethod = with_(requestInit, {method})
    return withBody(requestInitWithMethod, body)
}

export {buildFetchOptions}
